module.exports = __webpack_public_path__ + "img/rf_signal.5c12e0ea.svg";